module.exports = __webpack_public_path__ + "static/media/arrow.738f322a.svg";